import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const EmailMaker = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    education: "",
    hasExperience: "No",
    yearsOfExperience: "",
    reasonForNoExperience: "", // New state for "Why?" input
    imageUrl: "",
  });

  const [showPreview, setShowPreview] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    setShowPreview(true);
  };

  const replaceFrenchCharacters = (text) => {
    const replacements = {
      é: "&eacute;",
      è: "&egrave;",
      ê: "&ecirc;",
      à: "&agrave;",
      ç: "&ccedil;",
      î: "&icirc;",
      ï: "&iuml;",
      ô: "&ocirc;",
      ù: "&ugrave;",
      û: "&ucirc;",
    };
    return text.replace(/[\u00E0-\u00FC]/g, (char) => replacements[char] || char);
  };

  const saveAsHtmlFile = async () => {
    const {
      name,
      email,
      education,
      hasExperience,
      yearsOfExperience,
      reasonForNoExperience,
      imageUrl,
    } = formData;

    const safeName = replaceFrenchCharacters(name);
    const safeEmail = replaceFrenchCharacters(email);
    const safeEducation = replaceFrenchCharacters(education);

    const cvHtml = `
      <!DOCTYPE html>
      <html lang="en">
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Generated CV</title>
        <style>
          body { font-family: Arial, sans-serif; margin: 20px; }
          h1, h2 { text-align: center; }
          p, h3 { margin: 10px 0; }
          img { max-width: 100%; height: auto; display: block; margin: 0 auto 10px; }
        </style>
      </head>
      <body>
        <h1>${safeName}</h1>
        <img src="${imageUrl}" alt="${safeName}'s Image">
        <p><strong>Email:</strong> ${safeEmail}</p>
        <h3>Education</h3>
        <p>${safeEducation}</p>
        ${
          hasExperience === "Yes"
            ? `<h3>Experience</h3><p>${yearsOfExperience} years</p>`
            : `<h3>Reason for No Experience</h3><p>${reasonForNoExperience}</p>`
        }
      </body>
      </html>
    `;

    try {
      if (window.showSaveFilePicker) {
        const handle = await window.showSaveFilePicker({
          suggestedName: "Generated_CV.html",
          types: [
            {
              description: "HTML Files",
              accept: { "text/html": [".html"] },
            },
          ],
        });

        const writable = await handle.createWritable();
        await writable.write(cvHtml);
        await writable.close();
        toast.success("File saved successfully!");
      } else {
        const blob = new Blob([cvHtml], { type: "text/html" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "Generated_CV.html";
        link.click();
        URL.revokeObjectURL(link.href);
        toast.success("File saved successfully!");
      }
    } catch (error) {
      console.error("Error saving file:", error);
      toast.error("Failed to save the file!");
    }
  };

  return (
    <div style={{ fontFamily: "Arial, sans-serif", padding: "20px", backgroundColor: "#f4f4f9" }}>
      <h1 style={{ textAlign: "center" }}>CV Maker with Image</h1>
      <form
        onSubmit={handleFormSubmit}
        style={{
          maxWidth: "500px",
          margin: "0 auto",
          padding: "20px",
          background: "#fff",
          borderRadius: "8px",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        }}
      >
        <label style={{ fontWeight: "bold" }}>Full Name:</label>
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleInputChange}
          placeholder="Enter your name"
          required
        />

        <label style={{ fontWeight: "bold" }}>Email:</label>
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleInputChange}
          placeholder="Enter your email"
          required
        />

        <label style={{ fontWeight: "bold" }}>Education:</label>
        <textarea
          name="education"
          value={formData.education}
          onChange={handleInputChange}
          placeholder="Enter your education details"
          rows="4"
          required
        ></textarea>

        <label style={{ fontWeight: "bold" }}>Do you have work experience?</label>
        <select
          name="hasExperience"
          value={formData.hasExperience}
          onChange={handleInputChange}
          style={{ width: "100%", marginBottom: "10px", padding: "5px" }}
        >
          <option value="No">No</option>
          <option value="Yes">Yes</option>
        </select>

        {formData.hasExperience === "No" && (
          <>
            <label style={{ fontWeight: "bold" }}>Why?</label>
            <textarea
              name="reasonForNoExperience"
              value={formData.reasonForNoExperience}
              onChange={handleInputChange}
              placeholder="Explain why you have no experience"
              rows="2"
              style={{ width: "100%", marginBottom: "10px", padding: "5px" }}
              required
            ></textarea>
          </>
        )}

        {formData.hasExperience === "Yes" && (
          <>
            <label style={{ fontWeight: "bold" }}>How many years of experience?</label>
            <input
              type="number"
              name="yearsOfExperience"
              value={formData.yearsOfExperience}
              onChange={handleInputChange}
              placeholder="Enter years of experience"
              style={{ width: "100%", marginBottom: "10px", padding: "5px" }}
              required
            />
          </>
        )}

        <label style={{ fontWeight: "bold" }}>Image URL:</label>
        <input
          type="text"
          name="imageUrl"
          value={formData.imageUrl}
          onChange={handleInputChange}
          placeholder="Enter image URL"
        />

        <button
          type="submit"
          style={{
            width: "100%",
            margin: "10px 0",
            padding: "10px",
            background: "#007bff",
            color: "#fff",
            fontWeight: "bold",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Generate CV
        </button>
      </form>

      {showPreview && (
        <div
          style={{
            margin: "20px auto",
            maxWidth: "600px",
            background: "#fff",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
          }}
        >
          <h2 style={{ textAlign: "center" }}>CV Preview</h2>
          <img
            src={formData.imageUrl}
            alt={`${formData.name}'s Image`}
            style={{ maxWidth: "100%", height: "auto", display: "block", marginBottom: "10px" }}
          />
          <p>
            <strong>Name:</strong> {formData.name}
          </p>
          <p>
            <strong>Email:</strong> {formData.email}
          </p>
          <h3>Education</h3>
          <p>{formData.education}</p>
          {formData.hasExperience === "Yes" && (
            <>
              <h3>Experience</h3>
              <p>{formData.yearsOfExperience} years</p>
            </>
          )}
          {formData.hasExperience === "No" && (
            <>
              <h3>Reason for No Experience</h3>
              <p>{formData.reasonForNoExperience}</p>
            </>
          )}
          <button
            onClick={saveAsHtmlFile}
            style={{
              width: "100%",
              margin: "10px 0",
              padding: "10px",
              background: "#28a745",
              color: "#fff",
              fontWeight: "bold",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Save as HTML
          </button>
        </div>
      )}
      <ToastContainer />
    </div>
  );
};

export default EmailMaker;
